<template>
  <div class="app-container">
    <div class="md_list_box" @click="editPass = true">
      <div class="md_img_box">
        <img :src="require('@/assets/img/pop_account_psd.png')" alt="">
      </div>
      <span>修改密码</span>
    </div>
    <div class="md_list_box" @click="bindPhoneShow = true" v-if="!status.bindPhone">
      <div class="md_img_box">
        <img :src="require('@/assets/img/pop_account_phone.png')" alt="">
      </div>
      <span>绑定手机</span>
    </div>
    <div class="md_list_box" @click="realNameShow = true" v-if="!status.true_name">
      <div class="md_img_box">
        <img :src="require('@/assets/img/pop_account_name.png')" alt="">
      </div>
      <span>实名认证</span>
    </div>
    <div class="md_list_box" @click="openBack = true">
      <div class="md_img_box">
        <img :src="require('@/assets/img/pop_account_off.png')" alt="">
      </div>
      <span>注销账户</span>
    </div>

    <!-- 修改密码 -->
    <mu-dialog class="mudia" :padding="20" width="360" scrollable :open.sync="editPass" :overlay-close="false">
      <div class="md_title" :style="{background: themeConfig.dark}">
        <div class="md_title_txt" :style="{color: themeConfig.light}">修改密码</div>
        <mu-icon class="icon" size="30" value="close" color="white" @click="editPass = !editPass"></mu-icon>
      </div>
      <div class="md_content">
        <div class="pd02">
          <mu-form :model="pwdForm" class="mu-demo-form">
            <mu-text-field full-width icon="locked" :underline-color="themeConfig.dark" :color="themeConfig.dark" type="password" v-model="pwdForm.old_password" placeholder="请输入原密码"></mu-text-field>
            <mu-text-field full-width icon="locked" :underline-color="themeConfig.dark" :color="themeConfig.dark" type="password" v-model="pwdForm.password" placeholder="请输入新密码"></mu-text-field>
            <mu-text-field full-width icon="locked" :underline-color="themeConfig.dark" :color="themeConfig.dark" type="password" v-model="pwdForm.password_confirmation" placeholder="再次确认密码"></mu-text-field>
            <mu-button full-width :color="themeConfig.dark" v-loading="pwdFormLoading" @click="updatePassword">确认提交</mu-button>
          </mu-form>
        </div>
      </div>
    </mu-dialog>

    <!-- 绑定手机 -->
    <mu-dialog class="mudia" :padding="20" width="360" scrollable :open.sync="bindPhoneShow" :overlay-close="false">
      <div class="md_title" :style="{background: themeConfig.dark}">
        <div class="md_title_txt" :style="{color: themeConfig.light}">绑定手机</div>
        <mu-icon class="icon" size="30" value="close" color="white" @click="bindPhoneShow = !bindPhoneShow"></mu-icon>
      </div>
      <div class="md_content">
        <div class="pd02">
          <mu-form :model="bindPhoneForm" class="mu-demo-form">
            <mu-text-field full-width icon="phone" type="number" :underline-color="themeConfig.dark" :color="themeConfig.dark" v-model="bindPhoneForm.phone" placeholder="请输入手机号码"></mu-text-field>
            <mu-text-field full-width icon="verified_user" type="number" :underline-color="themeConfig.dark" :color="themeConfig.dark" v-model="bindPhoneForm.code" placeholder="请输入验证码">
              <mu-button :disabled="codeDisabled" append flat :color="themeConfig.dark" small @click="getCode">{{codeDisabled ? `${codeTime}s`: '获取验证码'}}</mu-button>
            </mu-text-field>
            <mu-button full-width :color="themeConfig.dark" @click="bindPhone" v-loading="bindPhoneFormLoading">确认绑定</mu-button>
          </mu-form>
        </div>
      </div>
    </mu-dialog>

    <!-- 实名认证 -->
    <mu-dialog class="mudia" :padding="20" width="360" scrollable :open.sync="realNameShow" :overlay-close="false">
      <div class="md_title" :style="{background: themeConfig.dark}">
        <div class="md_title_txt" :style="{color: themeConfig.light}">实名认证</div>
        <mu-icon class="icon" size="30" value="close" color="white" @click="realNameShow = !realNameShow"></mu-icon>
      </div>
      <div class="md_content">
        <div class="pd02">
          <mu-form :model="realNameForm" class="mu-demo-form">
            <mu-text-field full-width icon="account_circle" :underline-color="themeConfig.dark" :color="themeConfig.dark" v-model="realNameForm.realname" placeholder="请输入真实姓名"></mu-text-field>
            <mu-select icon="contact_mail" v-model="realNameForm.type" :color="themeConfig.dark" full-width placeholder="请选择证件类型">
              <mu-option label="身份证" :value="1"></mu-option>
            </mu-select>
            <mu-text-field full-width icon="credit_card" :underline-color="themeConfig.dark" :color="themeConfig.dark" v-model="realNameForm.idcard" placeholder="请输入证件号"></mu-text-field>
            <mu-button full-width :color="themeConfig.dark" @click="verified" v-loading="realNameFormLoading">确认绑定</mu-button>
          </mu-form>
        </div>
      </div>
    </mu-dialog>

    <!-- 领取礼包盒的dialog -->
    <mu-dialog width="300" :open.sync="openBack" :esc-press-close="false" :overlay-close="false">
      <div class="dialog-box">
        <div class="title-box">
          <p class="dl-title">提示</p>
          <mu-icon value="close" class="close" @click="openBack = false"></mu-icon>
        </div>
        <div class="dl-cont">
          <p>游戏这么好玩，您确定要退出吗？</p>
        </div>
        <div class="bot-btn">
          <mu-button class="btn" color="#B3AFA5" small v-loading="backLoading" @click="backGame">我要退出</mu-button>
          <mu-button class="btn" :color="themeConfig.dark" small @click="openBack = false">继续玩玩</mu-button>
        </div>
      </div>
    </mu-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { updatePassword, bindPhone } from '@/api/register'
import { verified, logout } from '@/api/login'
import { validate } from '@/utils/validate'
import { sendBindSms } from '@/api/sendSms'
import { setToken, setSession, newPromise, removeToken } from '@/utils'
import { getWechatCode } from '@/api/getWechatCode'
import Cookies from 'js-cookie'

export default {
  name: 'User',
  props: {
    realName: {
      type: Boolean,
      default: false
    },
    bindPhoneStatus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pwdFormLoading: false, //  修改密码loading
      realNameFormLoading: false, //  实名认证loading
      bindPhoneFormLoading: false, //  绑定手机loading
      adminLoading: false, //  切换账号登陆loading
      levelFormLoading: false, // 升级账号loading
      backLoading: false, //  点击我要退出的loading
      openBack: false, //  退出账号的dialog
      active: 0,
      pwdForm: { //  修改密码
        old_password: '',
        password: '',
        password_confirmation: ''
      },
      realNameForm: { //  实名验证
        realname: '',
        idcard: '',
        type: 1
      },
      bindPhoneForm: { //  绑定手机
        phone: '',
        code: ''
      },
      loginPhoneForm: { //  切换账号
        username: '',
        password: ''
      },
      levelForm: { //  账号升级
        username: '',
        password: '',
        code: ''
      },
      codeTime: 0, // 倒计时
      codeDisabled: false,
      levelCodeDisabled: false, //  账号升级获取验证码
      levelCodeTime: 0, //  倒计时
      isGetWechatCode: true, //  是否可点击获取微信验证码
      editPass: false,
      bindPhoneShow: false,
      realNameShow: false
    }
  },
  methods: {
    // 登陆
    async login (loginType) {
      let obj = {}
      let status = false
      status = validate([{ val: this.loginPhoneForm.username, msg: '账号不能为空' }, { val: this.loginPhoneForm.password, msg: '密码不能为空' }, { val: this.loginPhoneForm.wechat_code, options: { id: this.init.identity } }])
      if (status) {
        obj = { login_type: 'ACCOUNT', ...this.loginPhoneForm }
        if (this.init.identity === 885) {
          obj.wechat_code = this.loginPhoneForm.wechat_code
        }
        this.adminLoading = true
        const res = await this.$store.dispatch('login', obj)
        this.adminLoading = false
        if (res.error_code) {
          this.$toast.error(res.msg ? res.msg : '请求错误')
        } else {
          setToken(res.data.access_token)
          setSession(res.data.session_id)
          this.loginUser(this.loginPhoneForm) //  登陆记住账号
          this.openSimple = false
          this.$store.commit('SET_TOKEN', res.data.access_token)
          this.$store.commit('SET_SESSION_ID', res.data.session_id)
          this.$toast.success('登录成功')
          this.loginPhoneForm = this.$options.data().loginPhoneForm
          location.reload()
        }
      }
    },
    async updatePassword () {
      let status = false
      status = validate([{ val: this.pwdForm.old_password, msg: '原密码不能为空' }, { val: this.pwdForm.password, msg: '新密码不能为空' }, { val: [this.pwdForm.password, this.pwdForm.password_confirmation], options: 'same' }, { val: [this.pwdForm.old_password, this.pwdForm.password], options: 'noSame' }])
      if (status) {
        this.pwdFormLoading = true
        const res = await newPromise(updatePassword, this.pwdForm)
        this.pwdFormLoading = false
        if (res.ret === 1) {
          this.$toast.success('密码修改成功')
          this.loginUser({ username: this.status.user_name, password: this.pwdForm.password })
          this.pwdForm = this.$options.data().pwdForm
        } else {
          this.$toast.error(res.msg ? res.msg : '请求错误')
        }
      }
    },
    async verified () { //  实名认证
      let status = false
      status = validate([{ val: this.realNameForm.realname, msg: '真实姓名不能为空' }, { val: this.realNameForm.type, msg: '证件类型不能为空' }, { val: this.realNameForm.idcard, msg: '证件号不能为空' }])
      if (status) {
        this.realNameFormLoading = true
        const res = await newPromise(verified, { id_card: this.realNameForm.idcard, true_name: this.realNameForm.realname })
        this.realNameFormLoading = false
        if (res.ret === 1) {
          setToken(res.data.session_id)
          this.$store.commit('SET_TOKEN', res.data.session_id) //   替换返回的token
          this.$toast.success('实名认证成功')
          this.realNameForm = this.$options.data().realNameForm
          this.realNameShow = false
          this.$store.commit('SET_GIFTSTATUS', false) //  实名验证后允许重新拉取礼包
          this.getStatus()
          this.$emit('setGameUrl')
          this.$emit('closeHeartbeatWindow')
          // this.$parent.$parent.$parent.$parent.setGameUrl()
          // this.$parent.$parent.$parent.$parent.closeHeartbeatWindow()
        } else {
          this.$toast.error(res.msg ? res.msg : '请求错误')
        }
      }
    },
    async backGame () { //  退出游戏
      this.backLoading = true
      const res = await newPromise(logout)
      this.backLoading = false
      if (res.ret === 1) {
        removeToken()
        if (this.status.use_heart) {
          const gameId = this.init.identity || ''
          const uid = this.status.uid || ''
          Cookies.remove(`htoken_${gameId}_${uid}`)
        }
        this.$toast.success('退出成功')
        try {
          sessionStorage.setItem('username', this.status.user_name)
        } catch (e) {}
        location.reload()
      } else {
        this.$toast.error(res.msg ? res.msg : '请求错误')
      }
    },
    //  升级账号的
    // async level () {
    //   let status = false
    //   status = validate([{ val: this.status.mobile, msg: '请先绑定手机号' }, { val: this.levelForm.username, msg: '用户名不能为空' }, { val: this.levelForm.password, msg: '密码不能为空' }, { val: this.levelForm.code, msg: '验证码不能为空' }])
    //   if (status) {
    //     this.levelFormLoading = true
    //     const res = await newPromise(accountUp, this.levelForm)
    //     this.levelFormLoading = false
    //     if (!res.error_code) {
    //       this.removeUser({ username: this.status.user_name })
    //       this.$toast.success('账号升级成功，请重新登陆')
    //       removeToken()
    //       removeSession()
    //       if (this.init.heartbeat_interval >= 60) {
    //         const gameId = this.init.identity || ''
    //         const uid = this.status.user_id || ''
    //         Cookies.remove(`htoken_${gameId}_${uid}`)
    //       }
    //       this.$store.commit('SET_TOKEN', '')
    //       this.$store.commit('SET_SESSION_ID', '')
    //       window.location.reload()
    //     } else {
    //       this.$toast.error(res.msg ? res.msg : '请求错误')
    //     }
    //   }
    // },
    async getCode (type) { //  获取验证码
      let status = false
      status = validate([{ val: this.bindPhoneForm.phone, options: 'phone' }])
      if (status) {
        this.codeDisabled = true
        this.codeTime = 60
        let obj = {
          phone: this.bindPhoneForm.phone.trim()
        }
        if (this.init.identity === 846) {
          obj.head = 'qtwl'
        }
        const res = await newPromise(sendBindSms, obj)
        if (res.ret === 1) {
          this.$toast.success('发送成功')
        } else {
          this.codeDisabled = false
          this.$toast.error(res.msg ? res.msg : '请求错误')
        }
      }
    },
    async bindPhone () { //  绑定手机
      let status = false
      status = validate([{ val: this.bindPhoneForm.phone, options: 'phone' }, { val: this.bindPhoneForm.code, msg: '验证码不能为空' }])
      if (status) {
        this.bindPhoneFormLoading = true
        const res = await newPromise(bindPhone, this.bindPhoneForm)
        this.bindPhoneFormLoading = false
        if (res.ret === 1) {
          setToken(res.data.session_id)
          this.$store.commit('SET_TOKEN', res.data.session_id) //   替换返回的token
          this.$toast.success('手机号绑定成功')
          this.bindPhoneForm = this.$options.data().bindPhoneForm
          this.bindPhoneShow = false
          location.reload()
        } else {
          this.$toast.error(res.msg ? res.msg : '请求错误')
        }
      }
    },
    async getInit () {
      const res = await this.$store.dispatch('getInit')
      if (res.error_code) {
        this.$toast.error(res.msg ? res.msg : '请求错误')
      }
    },
    async getStatus () {
      const res = await this.$store.dispatch('getStatus')
      if (res.error_code) {
        this.$toast.error(res.msg ? res.msg : '请求错误')
      }
    },
    // 登记账号
    loginUser (obj) {
      if (localStorage.getItem('userList')) {
        const arr = JSON.parse(localStorage.getItem('userList'))
        if (!arr.some(v => { return v.username === obj.username })) {
          arr.length > 9 && arr.shift()
          arr.push(obj)
          localStorage.setItem('userList', JSON.stringify(arr))
        } else {
          arr.forEach(v => {
            if (v.username === obj.username) {
              v.username = obj.username
              v.password = obj.password
            }
          })
          localStorage.setItem('userList', JSON.stringify(arr))
        }
      } else {
        const arr = [obj]
        localStorage.setItem('userList', JSON.stringify(arr))
      }
    },
    // 清空账号
    removeUser (obj) {
      if (localStorage.getItem('userList')) {
        const arr = JSON.parse(localStorage.getItem('userList'))
        var i
        arr.forEach((item, index) => {
          if (item.username === obj.username) {
            i = index
          }
        })
        if (i) {
          arr.splice(i, 1)
          localStorage.setItem('userList', JSON.stringify(arr))
        }
      }
    },
    // 获取微信验证码
    async getWechatCode () {
      if (this.isGetWechatCode) {
        const status = validate([{ val: this.loginPhoneForm.username, msg: '账号不能为空' }])
        if (status) {
          this.isGetWechatCode = false
          const res = await getWechatCode({ username: this.loginPhoneForm.username })
          if (res.data.error_code) {
            this.isGetWechatCode = true
            this.$toast.error(res.data.msg)
            if (res.data.error_code === 2025) {
              // 设置顶层的弹窗
              this.$parent.$parent.$parent.openWxQrCode = true
            }
          } else {
            this.$toast.success('发送验证码成功')
          }
        }
      }
    },
    showRealName () {
      this.realNameShow = true
    },
    showBindPhone () {
      this.bindPhoneShow = true
    }
  },
  watch: {
    codeTime (val) {
      if (val > 0) {
        setTimeout(() => {
          this.codeTime > 0 && this.codeTime--
        }, 1000)
      } else {
        this.codeDisabled = false
      }
    },
    levelCodeTime (val) {
      if (val > 0) {
        setTimeout(() => {
          this.levelCodeTime > 0 && this.levelCodeTime--
        }, 1000)
      } else {
        this.levelCodeDisabled = false
      }
    },
    realName (val) {
      if (val) {
        this.active = 1
      }
    },
    bindPhoneStatus (val) {
      if (val) {
        this.active = 2
      }
    },
    'loginPhoneForm.username': function () {
      this.isGetWechatCode = true
    }
  },
  computed: {
    ...mapGetters([
      'status',
      'themeConfig',
      'init'
    ])
  }
}
</script>

<style lang="less" scoped>
.item-box {
  position: relative;
  .item {
    padding: .3rem;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}
.mu-input {
  margin-bottom: 0;
  font-size: .18rem;
  display: block;
}
.flat-btn {
  border: .01rem solid;
  width: 100%;
  margin-top: .3rem;
}
.dialog-box {
  position: relative;
  .title-box {
    position: absolute;
    top: -22px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    .dl-title {
      font-size: .26rem;
      color: #57534E;
      text-align: center;
      width: 100%;
      padding: .3rem 0;
    }
    .close {
      position: absolute;
      right: -10px;
      top: 12px;
      font-size: .5rem;
      color: #CCCBCA;
    }
  }
  .dl-cont {
    p {
      font-size: .22rem;
      text-align: center;
      padding: .8rem 0 .4rem;
      color: #57534E;
    }
  }
  .bot-btn {
    display: flex;
    justify-content:space-between;
    .btn {
      margin: 0 .2rem;
    }
  }
}
.mu-demo-form {
  .tips {
    text-align: center;
    font-size: .2rem;
    color: #57534E;
    line-height: .3rem;
    padding-top: .1rem;
  }
}
.tips-box {
  background: #F4F5F9;
  color: #666;
  border-radius: .2rem;
  font-size: .2rem;
  padding: .1rem .24rem;
}

.pd02 {
  padding: 0 .2rem;
}

.md_img_box {
  width: .5rem;
  height: .5rem;
  position: relative;
  margin: .15rem .2rem;
  img {
    width: 90%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
}
.mudia {
  /deep/ .mu-dialog-body {
    padding: 0;
  }
  /deep/ .mu-dialog {
    border-radius: .14rem;
    overflow: hidden;
  }
  /deep/ .mu-tab {
    font-size: 12px;
  }
}
</style>
